export default "__VITE_ASSET__3u0EMRit__"